"use strict";
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var SessionType;
(function (SessionType) {
    SessionType["FederatedProviderSession"] = "FederatedProviderSession";
})(SessionType = exports.SessionType || (exports.SessionType = {}));
var MFAType;
(function (MFAType) {
    MFAType["SMS_MFA"] = "SMS_MFA";
    MFAType["SOFTWARE_TOKEN_MFA"] = "SOFTWARE_TOKEN_MFA";
})(MFAType = exports.MFAType || (exports.MFAType = {}));
var FederatedProvider;
(function (FederatedProvider) {
    FederatedProvider["Google"] = "Google";
    FederatedProvider["Facebook"] = "Facebook";
    FederatedProvider["Amazon"] = "Amazon";
    FederatedProvider["Developer"] = "Developer";
})(FederatedProvider = exports.FederatedProvider || (exports.FederatedProvider = {}));
function isUsernamePasswordOpts(obj) {
    return !!obj.username;
}
exports.isUsernamePasswordOpts = isUsernamePasswordOpts;
//# sourceMappingURL=Auth.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-amplify/auth/lib/types/Auth.js
// module id = 1069
// module chunks = 18